/**
 * Карта v3 — константы движка.
 *
 * Мировые единицы: 1 unit = 1 px при zoom = 1. Ось Y вниз.
 * Всё, что влияет на геометрию чертежа, собрано здесь, чтобы схема
 * оставалась согласованной: шаг привязки, шаг кабелей, отступы, вылеты.
 */

// --- сетка и трассировка ---
export const GRID = 8;          // шаг привязки при перетаскивании
export const PITCH = 14;        // расстояние между соседними кабелями в общем канале
export const STUB = 18;         // вылет из порта перпендикулярно корпусу
export const CLEAR = 12;        // зазор, который трасса держит от корпуса устройства
export const CORNER = 7;        // радиус скругления угла трассы
export const HOP = 5;           // высота «мостика» на пересечении линий

// --- узлы ---
export const NODE_W = 108;
export const NODE_H = 66;
export const NODE_R = 8;        // скругление корпуса

// --- контейнеры локаций ---
export const PAD = 26;          // внутренний отступ до детей
export const PAD_TOP = 38;      // место под заголовок локации
export const GAP = 34;          // зазор между соседними контейнерами
export const CONT_R = 12;

// --- вьюпорт ---
export const ZOOM_MIN = 0.06;
export const ZOOM_MAX = 4;
export const ZOOM_STEP = 1.12;

// --- пороги детализации (LOD) ---
export const LOD = {
  DOT: 0.18,      // ниже — устройства точками, связи одним цветом
  PLAIN: 0.42,    // ниже — корпуса без иконок и без подписей связей
  FULL: 0.95,     // выше — IP, имена интерфейсов, мостики
};

// --- допуски попадания мышью (в экранных пикселях) ---
export const HIT = {
  EDGE: 7,
  HANDLE: 9,
  PORT: 8,
  RESIZE: 8,
};

// --- поиск пути ---
export const ROUTER = {
  TURN_COST: 34,        // штраф за поворот — держит трассы прямыми
  CROSS_COST: 26,       // штраф за пересечение чужой трассы
  WALL_COST: 260,       // цена пересечения рамки локации: дорого, но не запрещено
  NEAR_COST: 10,        // штраф за проход впритык к препятствию
  MAX_NODES: 9000,      // потолок раскрытых вершин, дальше — запасной путь
  BUDGET_MS: 26,        // бюджет на пачку перетрассировок в кадре
};

export const THEME = {
  light: {
    bg: '#f6f7f9',
    grid: '#e3e7ec',
    gridStrong: '#d3d9e0',
    contFill: '#ffffff',
    contText: '#334155',
    node: '#ffffff',
    nodeBorder: '#cbd5e1',
    nodeText: '#0f172a',
    nodeSub: '#64748b',
    sel: '#2563eb',
    selSoft: 'rgba(37,99,235,0.14)',
    handle: '#f59e0b',
    port: '#94a3b8',
    labelBg: 'rgba(255,255,255,0.92)',
    labelText: '#334155',
    labelBorder: '#dbe1e8',
    guide: '#ec4899',
    shadow: 'rgba(15,23,42,0.10)',
  },
  dark: {
    bg: '#0f141b',
    grid: '#1b2430',
    gridStrong: '#26313f',
    contFill: '#151c25',
    contText: '#cbd5e1',
    node: '#1c2430',
    nodeBorder: '#334155',
    nodeText: '#e2e8f0',
    nodeSub: '#94a3b8',
    sel: '#60a5fa',
    selSoft: 'rgba(96,165,250,0.18)',
    handle: '#fbbf24',
    port: '#64748b',
    labelBg: 'rgba(15,20,27,0.92)',
    labelText: '#cbd5e1',
    labelBorder: '#2b3646',
    guide: '#f472b6',
    shadow: 'rgba(0,0,0,0.45)',
  },
};

export const DASH = {
  solid: [],
  dashed: [10, 6],
  dotted: [2, 5],
  double: [],
};

export const SIDES = ['N', 'E', 'S', 'W'];
